export function uniqByProp(arr: any[], prop: string): any[] {
  return Array.from(new Set(arr.map((item) => item[prop]))).map((searchedProp) =>
    arr.find((item) => item[prop] == searchedProp)
  );
}
